import React, {useEffect, useState} from 'react';

import BlCategoryItem from './BlCategoryItem';

import './blCategory.scss';

const BlCategory = ({blCategory, selectedBusinessLunch, addBlItem, selectedItems, menuItemTypes}) => {
  const [blCategoryItems, setBlCategoryItems] = useState([]);

  useEffect(() => {
    if (!selectedBusinessLunch || !selectedBusinessLunch.relations || selectedBusinessLunch.relations.length === 0) {
      return;
    }

    const menuItemsIds = selectedBusinessLunch.relations.filter(r => r.category_item_id === blCategory.menu_item_id).map(r => r.menu_item_id);
    const menuItems = menuItemsIds.map(id => selectedBusinessLunch.menuItems.find(mi => mi.menu_item_id === id)).filter(Boolean);
    
    setBlCategoryItems(menuItems);
  }, [blCategory]);

  const onAddBlItem = (item) => {
    const relation = selectedBusinessLunch.relations.find(r => r.category_item_id === blCategory.menu_item_id && r.menu_item_id === item.menu_item_id);

    relation.restrictions = selectedBusinessLunch.category_relations.find(cr => cr.menu_item_id === relation.category_item_id);
    addBlItem(item, blCategory, relation);
  };

  if (!blCategory) {
    return (<></>);
  }

  return (
    <div className={ 'bl-category' }>
      <div className={ 'category-header' }>
        {blCategory.item_name}
      </div>
      <div className={ 'items-list' }>
        {
          blCategoryItems.map(item => (
            <BlCategoryItem blCategoryItem={ item } blCategory={ blCategory } addBlItem={ onAddBlItem } selectedItems={ selectedItems } selectedBusinessLunch={selectedBusinessLunch} menuItemTypes={menuItemTypes}/>
          ))
        }
      </div>

    </div>
  );
};

export default BlCategory;
